import { createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6120d826"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "productInfo-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "module-title"
}, "智能体介绍", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 无垠协议模糊测试智能体通过向被测协议对象提供非预期的输入并监视异常结果，自动化检测系统缺陷并验证协议功能，并提出高质量修复建议。从源头助力企业实现自动化安全检测，提升协议应用的安全性与健壮性。 ", -1));
const _hoisted_4 = {
  class: "content-box"
};
const _hoisted_5 = {
  class: "left-box"
};
const _hoisted_6 = {
  class: "item-box one"
};
const _hoisted_7 = {
  class: "shield-box"
};
const _hoisted_8 = {
  class: "icon"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "蓝牙协议、WiFi协议", -1));
const _hoisted_10 = {
  class: "item-box two"
};
const _hoisted_11 = {
  class: "shield-box"
};
const _hoisted_12 = {
  class: "icon"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "区块链协议", -1));
const _hoisted_14 = {
  class: "item-box three"
};
const _hoisted_15 = {
  class: "shield-box"
};
const _hoisted_16 = {
  class: "icon"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "数据库协议", -1));
const _hoisted_18 = {
  class: "center-box"
};
const _hoisted_19 = {
  class: "center"
};
const _hoisted_20 = {
  class: "cloud",
  alt: "云起无垠"
};
const _hoisted_21 = {
  class: "item-box center-item"
};
const _hoisted_22 = {
  class: "shield-box"
};
const _hoisted_23 = {
  class: "icon"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "更多", -1));
const _hoisted_25 = {
  class: "right-box"
};
const _hoisted_26 = {
  class: "item-box one"
};
const _hoisted_27 = {
  class: "shield-box"
};
const _hoisted_28 = {
  class: "icon"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "私有金融协议", -1));
const _hoisted_30 = {
  class: "item-box two"
};
const _hoisted_31 = {
  class: "shield-box"
};
const _hoisted_32 = {
  class: "icon"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "工控协议", -1));
const _hoisted_34 = {
  class: "item-box three"
};
const _hoisted_35 = {
  class: "shield-box"
};
const _hoisted_36 = {
  class: "icon"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-box"
}, "5G协议", -1));
import { ref } from 'vue';
import { MOBILE_FUNC } from '@/uitl/currencyFunc';
export default {
  __name: 'productInfo',
  setup(__props) {
    let isMobile = MOBILE_FUNC(),
      proportion = ref(null),
      fatherBox = ref(null);
    if (isMobile) {
      // 移动端
      proportion.value = ``;
      fatherBox.value = ``;
    } else {
      // PC端
      // if(window.innerWidth <= 1920){
      //     proportion.value = `transform: scale(${(window.innerWidth * 1) / 1920}) translateY(${ (((window.innerWidth * 1) / 1920) - 1) * 280 }px);`
      //     fatherBox.value = ''
      // }else{
      proportion.value = `transform: scale(${window.innerWidth * 1 / 1920}) translateY(${(window.innerWidth * 1 / 1920 - 1) * 280}px);`;
      fatherBox.value = `height: ${window.innerWidth * 860 / 1920}px;`;
      // }
    }
    console.log(window.innerWidth, screen.width);
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", {
        class: "graphical-box",
        style: _normalizeStyle(_unref(fatherBox))
      }, [_createElementVNode("div", {
        class: "graphical",
        style: _normalizeStyle(_unref(proportion))
      }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon1.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_9])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [_withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon2.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_13])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [_withDirectives(_createElementVNode("i", _hoisted_16, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon3.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_17])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/radian-left.png'), "background-image"]]), _createElementVNode("div", _hoisted_18, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [_withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [[_directive_lazy, require('@/assets/img/codeProduct/product/cloud.png')]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/center-box-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, [_withDirectives(_createElementVNode("i", _hoisted_23, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon7.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_24])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [_withDirectives(_createElementVNode("i", _hoisted_28, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon4.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_29])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [_withDirectives(_createElementVNode("i", _hoisted_32, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon5.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_33])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_35, [_withDirectives(_createElementVNode("i", _hoisted_36, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productInfo-icon6.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/shield.png'), "background-image"]]), _hoisted_37])), [[_directive_lazy, require('@/assets/img/protocolProduct/base-bg.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/radian-right.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/protocolProduct/center-bg.png'), "background-image"]])], 4)], 4)]);
    };
  }
};